import { render } from "./BehalfRegistration.vue?vue&type=template&id=9841edfe&scoped=true"
import script from "./BehalfRegistration.vue?vue&type=script&lang=js"
export * from "./BehalfRegistration.vue?vue&type=script&lang=js"

import "./BehalfRegistration.vue?vue&type=style&index=0&id=9841edfe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9841edfe"]])

export default __exports__